import script from "./termsOfService.vue?vue&type=script&setup=true&lang=js"
export * from "./termsOfService.vue?vue&type=script&setup=true&lang=js"

import "./termsOfService.vue?vue&type=style&index=0&id=65b71c99&lang=less&scoped=true"

import exportComponent from "D:\\CODE\\joyjobs_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65b71c99"]])

export default __exports__